module.exports = __webpack_public_path__ + "static/img/图层 584.6a85e52f.png";